[
        {
           "value":"default",
           "imgPath":"",
           "viewValue":"Select a language"
        },
        {
            "value":"/login?LOCALE=en_US",
            "imgPath":"assets/icons/flag/icon-flag-us.svg",
            "viewValue":"English - All Others"
        },
        {
            "value":"/login?LOCALE=en_AU",
            "imgPath":"assets/icons/flag/icon-flag-australia.svg",
            "viewValue":"English - Australia"
        },
        {
            "value":"/login?LOCALE=en_IE",
            "imgPath":"assets/icons/flag/icon-flag-ireland.svg",
            "viewValue":"English - Ireland"
        },
        {
            "value":"/login?LOCALE=en_GB",
            "imgPath":"assets/icons/flag/icon-flag-uk.svg",
            "viewValue":"English - United Kingdom"
        },
        {
            "value":"/login?LOCALE=nl_NL",
            "imgPath":"assets/icons/flag/icon-flag-netherlands.svg",
            "viewValue":"Dutch - Netherlands"
        },
        {
            "value":"/login?LOCALE=fr_FR",
            "imgPath":"assets/icons/flag/icon-flag-france.svg",
            "viewValue":"French - France"
        },
        {
            "value":"/login?LOCALE=de_DE",
            "imgPath":"assets/icons/flag/icon-flag-germany.svg",
            "viewValue":"German - Germany"
        },
        {
            "value":"/login?LOCALE=it_IT",
            "imgPath":"assets/icons/flag/icon-flag-italy.svg",
            "viewValue":"Italian - Italy"
        },
        {
            "value":"/login?LOCALE=ko_KR",
            "imgPath":"assets/icons/flag/icon-flag-south-korea.svg",
            "viewValue":"Korean - Korea"
        },
        {
            "value":"/login?LOCALE=pt_BR",
            "imgPath":"assets/icons/flag/icon-flag-brazil.svg",
            "viewValue":"Portuguese - Brazil"
        },
        {
            "value":"/login?LOCALE=es_CL",
            "imgPath":"assets/icons/flag/icon-flag-chile.svg",
            "viewValue":"Spanish - Chile"
        },
        {
            "value":"/login?LOCALE=es_ES",
            "imgPath":"assets/icons/flag/icon-flag-spain.svg",
            "viewValue":"Spanish - Spain"
        }
]
